// src/lib/redux/utils/localCart.ts
export interface LocalCartItem {
  id: number; // cart item unique id (can just be product_id for guest)
  product_id: number;
  slug: string;
  product_name: string;
  product_thumbnail_image: string;
  is_preorder: number;
  price: number;
  currency_symbol: string;
  quantity: number;
  lower_limit: number;
  upper_limit: number;
}

const CART_KEY = "local_cart";

export const getLocalCart = (): LocalCartItem[] => {
  if (typeof window === "undefined") return [];
  const raw = localStorage.getItem(CART_KEY);
  return raw ? JSON.parse(raw) : [];
};

export const saveLocalCart = (cart: LocalCartItem[]) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(CART_KEY, JSON.stringify(cart));
};

export const addLocalCartItem = (product: any, quantity: number = 1): LocalCartItem[] => {
  const cart = getLocalCart();
  const existingIndex = cart.findIndex((item) => item.product_id === product.id);

  if (existingIndex > -1) {
    // update quantity
    cart[existingIndex].quantity += quantity;
  } else {
    cart.push({
      id: product.id,
      product_id: product.id,
      slug: product.slug,
      product_name: product.name,
      product_thumbnail_image: product.pictures?.[0]?.url || "",
      is_preorder: product.preorder_available ? 1 : 0,
      price: product.sale_price || product.price,
      currency_symbol: "৳", // or props.currency_symbol
      quantity,
      lower_limit: 1,
      upper_limit: product.max_qty || product.stock,
    });
  }

  saveLocalCart(cart);
  return cart;
};
export const addLocalCartItemQuantity = (product_id: number, quantity: number = 1): LocalCartItem[] => {
  const cart = getLocalCart();
  const existingIndex = cart.findIndex((item) => item.product_id === product_id);
    cart[existingIndex].quantity = quantity;
  saveLocalCart(cart);
  return cart;
};

export const removeLocalCartItem = (productId: number): LocalCartItem[] => {
  const cart = getLocalCart().filter((item) => item.product_id !== productId);
  saveLocalCart(cart);
  return cart;
};
export const removeAllLocalCart = (): [] => {
  saveLocalCart([]);
  return [];
};
